import { AbstractControl, FormControl, FormGroup, ValidatorFn } from '@angular/forms';

import { FieldValidatorsMap } from '../interfaces';

import { ObjectLike } from 'app/interfaces';

export class CustomRules {
    private validators: FieldValidatorsMap = {};

    constructor(public fieldValidatorsMap: FieldValidatorsMap) {
        this.generateValidators(fieldValidatorsMap);
    }

    getForm(initialValues: ObjectLike = {}): FormGroup {
        return this.getFormGroup(initialValues);
    }

    private createFormControl(field: string, value: unknown = null): FormControl {
        const validators: ValidatorFn[] = this.getFieldValidators(field);

        return new FormControl(value, validators);
    }

    private getFieldValidators(field: string): ValidatorFn[] {
        if (!this.validators.hasOwnProperty(field)) {
            return [];
        }
        return this.validators[field];
    }

    private getFormGroup(initialValues: ObjectLike = {}): FormGroup {
        const fields = Object.keys(this.getValidators());
        const controls: { [prop: string]: AbstractControl } = {};

        fields.forEach((field: string): void => {
            controls[field] = this.createFormControl(field, initialValues[field]);
        });

        return new FormGroup(controls);
    }

    private getValidators(): ObjectLike {
        return this.validators;
    }

    private generateValidators(fieldValidatorsMap: FieldValidatorsMap): void {
        for (const key in fieldValidatorsMap) {
            if (fieldValidatorsMap.hasOwnProperty(key)) {
                this.setValidator(key, fieldValidatorsMap[key]);
            }
        }
    }

    private setValidator(key: string, validators: ValidatorFn[]): void {
        this.validators[key] = validators;
    }
}
